function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getOrThrow } from '@deephaven/utils';
import GridMouseHandler from "../GridMouseHandler.js";
import GridUtils from "../GridUtils.js";
class GridRowMoveMouseHandler extends GridMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "cursor", 'move');
    _defineProperty(this, "draggingOffset", void 0);
  }
  onDown(gridPoint, grid) {
    var model = grid.props.model;
    var x = gridPoint.x,
      y = gridPoint.y,
      row = gridPoint.row;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var columnHeaderHeight = metrics.columnHeaderHeight,
      rowHeaderWidth = metrics.rowHeaderWidth,
      allRowYs = metrics.allRowYs;
    if (x <= rowHeaderWidth && row !== null && model.isRowMovable(row)) {
      var rowY = getOrThrow(allRowYs, row);
      this.draggingOffset = y - rowY - columnHeaderHeight;
      grid.setState({
        draggingRowOffset: this.draggingOffset
      });
    }
    return false;
  }
  onDrag(gridPoint, grid) {
    if (this.draggingOffset == null) {
      return false;
    }
    var model = grid.props.model;
    var draggingRow = grid.state.draggingRow;
    var _grid$state = grid.state,
      mouseX = _grid$state.mouseX,
      mouseY = _grid$state.mouseY;
    if (mouseX == null || mouseY == null) {
      return false;
    }
    if (draggingRow == null) {
      var _grid$getGridPointFro = grid.getGridPointFromXY(mouseX, mouseY),
        row = _grid$getGridPointFro.row;
      if (row != null && !model.isRowMovable(row)) {
        return false;
      }
      draggingRow = row;
      grid.setState({
        draggingRow,
        isDragging: true
      });
      if (draggingRow == null) {
        return false;
      }
    }
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var top = metrics.top,
      lastTop = metrics.lastTop,
      bottom = metrics.bottom,
      bottomVisible = metrics.bottomVisible,
      rowCount = metrics.rowCount,
      columnHeaderHeight = metrics.columnHeaderHeight,
      allRowHeights = metrics.allRowHeights,
      allRowYs = metrics.allRowYs,
      height = metrics.height;
    var minY = columnHeaderHeight;
    if (top < draggingRow) {
      var topRow = draggingRow - 1;
      minY = getOrThrow(allRowYs, topRow) + getOrThrow(allRowHeights, topRow) * 0.5 + columnHeaderHeight;
    }
    var maxY = height;
    if (draggingRow < bottom) {
      var bottomRow = draggingRow + 1;
      maxY = getOrThrow(allRowYs, bottomRow) + getOrThrow(allRowHeights, bottomRow) * 0.5 + columnHeaderHeight;
    }
    var movedRows = grid.state.movedRows;
    if (mouseY < minY && draggingRow > 0 && model.isRowMovable(draggingRow - 1)) {
      movedRows = GridUtils.moveItem(draggingRow, draggingRow - 1, movedRows);
      draggingRow -= 1;
    } else if (maxY < mouseY && draggingRow < rowCount - 1 && model.isRowMovable(draggingRow + 1)) {
      movedRows = GridUtils.moveItem(draggingRow, draggingRow + 1, movedRows);
      draggingRow += 1;
    }
    grid.setState({
      movedRows,
      draggingRow
    });
    var minMoveY = columnHeaderHeight + getOrThrow(allRowHeights, top) * 0.5;
    var maxMoveY = columnHeaderHeight + getOrThrow(allRowYs, bottomVisible) + getOrThrow(allRowHeights, bottomVisible) * 0.5;
    if (mouseY < minMoveY && top > 0) {
      grid.setState({
        top: top - 1
      });
    } else if (mouseY > maxMoveY && top < lastTop) {
      grid.setState({
        top: top + 1
      });
    }
    return true;
  }
  onUp(gridPoint, grid) {
    if (this.draggingOffset !== undefined) {
      this.draggingOffset = undefined;
      grid.setState({
        draggingRowOffset: null,
        draggingRow: null,
        isDragging: false
      });
      return true;
    }
    return false;
  }
}
export default GridRowMoveMouseHandler;
//# sourceMappingURL=GridRowMoveMouseHandler.js.map